import thumbnail from './thumbnail.png';
import Mediator from './Mediator';

export default {
    handle: 'courseWrapperPoise',
    label: 'POISE Course Wrapper',
    thumbnail,
    mediatorComponent: Mediator,
};
